import CalendarArrowLeftIcon from "./calendar-arrow-left"

const CalendarArrowRightIcon = () => {
    return (
        <CalendarArrowLeftIcon right={true} />
    )
}

export default CalendarArrowRightIcon
